var map = {
	"./Global.png": 5180,
	"./Joy.png": 739,
	"./Keno-01.png": 9047,
	"./Prime.png": 7182,
	"./Red and Blue.png": 8261,
	"./Red and White.png": 4825,
	"./Seven.png": 7646,
	"./Star.png": 3131,
	"./Viva.png": 879,
	"./jodanlogo-removebg-preview.png": 3508,
	"./logo.png": 6949
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;